(function () {
    'use strict';

    angular.module("imApp").factory("checkListItemCvsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1581,
                    parameters: parms || {}
                });
            },
            listCalculationAndValidations: function (parms) {
                return $ihttp.post({
                    method: 1580,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1582,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
